import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { LANDING_HTML } from "../landing/landingMarkup";
import { initLanding } from "../landing/landingEngine";

export default function Landing() {
  const rootRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const cleanup = initLanding();
    return cleanup;
  }, []);

  const onClick = (e) => {
    const a = e.target.closest ? e.target.closest("a[href^='/']") : null;
    if (a) {
      e.preventDefault();
      navigate(a.getAttribute("href"));
    }
  };

  return (
    <div
      ref={rootRef}
      data-testid="landing-root"
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: LANDING_HTML }}
    />
  );
}
